import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const CustomerSchemeProtectedRoute = () => {
  const authData = JSON.parse(sessionStorage.getItem("customer_scheme_auth") || "{}");
  return authData?.accessToken ? <Outlet /> : <Navigate to="/customer/login" replace />;
};

export default CustomerSchemeProtectedRoute;
